








/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETALLCUSTOMERREWARDSLISTFORAUTHUSER= createAsyncThunk(
  "getAllCustomerRewardsListForAuthUser/getAllCustomerRewardsListForAuthUser",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllCustomerRewardsListForAuthUserSlice = createSlice({
  name: "getAllCustomerRewardsListForAuthUserSlice",
  initialState: {
    getAllCustomerRewardsListForAuthUser: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllCustomerRewardsListForAuthUser: (state) => {
        state.getAllCustomerRewardsListForAuthUser.loading = false
        state.getAllCustomerRewardsListForAuthUser.error = false
        state.getAllCustomerRewardsListForAuthUser.data = []
        state.getAllCustomerRewardsListForAuthUser.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLCUSTOMERREWARDSLISTFORAUTHUSER.fulfilled, (state, action) => {
      state.getAllCustomerRewardsListForAuthUser = {
        ...state.getAllCustomerRewardsListForAuthUser,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLCUSTOMERREWARDSLISTFORAUTHUSER.pending, (state, action) => {
      state.getAllCustomerRewardsListForAuthUser = {
        ...state.getAllCustomerRewardsListForAuthUser,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLCUSTOMERREWARDSLISTFORAUTHUSER.rejected, (state, action) => {
      state.getAllCustomerRewardsListForAuthUser = {
        ...state.getAllCustomerRewardsListForAuthUser,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllCustomerRewardsListForAuthUserAction = {
    GETALLCUSTOMERREWARDSLISTFORAUTHUSER,
};

export { getAllCustomerRewardsListForAuthUserAction };
export default getAllCustomerRewardsListForAuthUserSlice.reducer;
export const {setInitialStateOfgetAllCustomerRewardsListForAuthUser} = getAllCustomerRewardsListForAuthUserSlice.actions
